import Dialog from "@mui/material/Dialog";
import BotoesInicioSimulacao from "@/pages/common/BotoesInicioSimulacao";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { getPrimaryColorButton } from "@/services/whitelabel";
import { useSelector } from "react-redux";

export default function DialogTipoItemPagamento({
  infoDialogTipoItemPagamento,
  setInfoDialogTipoItemPagamento,
}) {
  const user = useSelector((state) => state.user);
  const handleClose = () => {
    setInfoDialogTipoItemPagamento({ open: false });
  };
  const seleciona = (opcao) => {
    infoDialogTipoItemPagamento.selecionar(opcao);
    handleClose();
  };
  const voltar = () => {
    handleClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={infoDialogTipoItemPagamento.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogContent style={{ padding: "20px 5px" }}>
        <Typography
          align="center"
          variant="h6"
          sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}
          style={{ color: getPrimaryColorButton(user) }}>
          {!infoDialogTipoItemPagamento.useNewSimulator
            ? "Selecione o que deseja parcelar:"
            : "Selecione o que deseja parcelar para realizar a simulação:"}
        </Typography>
        <BotoesInicioSimulacao
          {...{ iniciaSimulacao: seleciona, voltar }}></BotoesInicioSimulacao>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}
